var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.349 20.7637H2.25762C1.56293 20.7637 1 20.2007 1 19.5061V13.1592C1 8.29637 4.94163 4.35583 9.80333 4.35583C14.665 4.35583 18.6067 8.29637 18.6067 13.1592V19.5061C18.6067 20.2007 18.0448 20.7637 17.349 20.7637Z",
    stroke: "#AFB7CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8825 2.51524C11.8825 3.9046 10.7567 5.03156 9.36729 5.03156C7.97901 5.03156 6.85205 3.9046 6.85205 2.51524C6.85205 1.12696 7.97901 0 9.36729 0C10.7567 0 11.8825 1.12696 11.8825 2.51524Z",
    fill: "#AFB7CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5304 20.8108C11.6317 21.0623 11.6818 21.3519 11.6818 21.6416C11.6818 22.9232 10.6496 23.9554 9.368 23.9554C8.08425 23.9554 7.0542 22.9232 7.0542 21.6416C7.0542 21.3519 7.10429 21.0623 7.20446 20.8108",
    stroke: "#AFB7CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Notification.d051fa59.svg";
export { ForwardRef as ReactComponent };